import { render } from "./CountryChoice.vue?vue&type=template&id=452fdf92"
import script from "./CountryChoice.vue?vue&type=script&lang=js"
export * from "./CountryChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__